import { httpClient } from './index';

// Sessions
export const loginUser = async ({ email, password }) => {
  const sessionData = { email, password };
  const { data } = await httpClient.post('/api/auth/sessions', sessionData);
  return data;
};

export const logoutUser = async () => {
  return httpClient.delete('/api/auth/sessions');
};

export const resetPassword = async ({ email }) => {
  return await httpClient.post('/api/auth/sessions/forgot', { email });
};

// Current XX
export const fetchCurrentUser = async () => {
  const result = await httpClient.get('/api/auth/current-user');
  const currentUser = result.data || {};
  const currentPatient = currentUser.patient || {};
  const currentProvider = currentUser.provider || {};
  const currentAdministrator = currentUser.administrator || {};

  return {
    id: currentUser.id,
    name: currentUser.name,
    firstName: currentUser.firstName,
    lastName: currentUser.lastName,
    email: currentUser.email,
    phone: currentUser.phone,
    admin: currentUser.admin,
    active: currentUser.active,
    patient: {
      id: currentPatient.id,
      zipcode: currentPatient.zipcode,
      gender: currentPatient.gender,
      birthdate: currentPatient.birthdate,
      insuranceName: currentPatient.insuranceName,
      insuranceId: currentPatient.insuranceId,
    },
    provider: {
      id: currentProvider.id,
      bio: currentProvider.bio,
      title: currentProvider.title,
      degree: currentProvider.degree,
      imageUrl: currentProvider.imageUrl,
      practiceId: currentProvider.practiceId,
      profileUrl: currentProvider.profileUrl,
      providerUrl: currentProvider.providerUrl,
      tenancies: (currentProvider.tenancies || [])
        .filter(tenancy => tenancy.active)
        .map(tenancy => ({
          id: tenancy.id,
          location: tenancy.location,
          virtualRoomUrl: tenancy.virtualRoomUrl,
        })),
    },
    administrator: {
      id: currentAdministrator.id,
      practiceId: currentAdministrator.practiceId,
      providers: currentAdministrator.providers,
    },
    isProvider: Boolean(currentUser.provider),
    isAdministrator: Boolean(currentUser.administrator),
    isPatient: Boolean(currentUser.patient),
    isPresent: Boolean(currentUser.id),
    notificationFilterStatus: currentUser.notificationFilterStatus,
  };
};

// export const fetchTrackingPatients = async (trackId) => {
//   return httpClient.get(`/api/track-patient/${trackId}`);
// };
export const fetchCurrentPractice = async () => {
  const result = await httpClient.get('/api/auth/current-practice');
  const practice = result.data || {};
  const { id, name, providers, administrators } = practice;

  return {
    id,
    name,
    providers: (providers || []).map(provider => ({
      id: provider.id,
      firstName: provider.firstName,
      lastName: provider.lastName,
      fullTitle: provider.fullTitle,
      name: provider.name,
      imageUrl: provider.imageUrl,
      tenancies: (provider.tenancies || []).map(tenancy => ({
        id: tenancy.id,
        location: tenancy.location,
        color: tenancy.color,
      })),
    })),
    administrators: (administrators || []).map(administrator => ({
      id: administrator.id,
      name: administrator.name,
      email: administrator.email,
    })),
  };
};

// Passwords
export const updatePassword = async ({ password, resetToken }) => {
  return await httpClient.put('/api/auth/passwords', { password, resetToken });
};

// Appointments

export const cancelAppointment = async ({ cancelToken }) => {
  return await httpClient.post('/api/auth/appointments/cancel', {
    cancelToken,
  });
};
